import { z } from 'zod'

export type CampaignPayload = z.infer<typeof CampaignPayloadSchema>

export const CampaignPayloadSchema = z.object({
  campaign: z.string(),
  image: z
    .object({
      web: z.object({
        url: z.string()
      })
    })
    .optional(),
  title: z.string(),
  description: z.string().optional(),
  topics: z
    .array(
      z.object({
        icon: z.string(),
        label: z.string()
      })
    )
    .optional(),
  actions: z.object({
    decline: z
      .object({
        label: z.string()
      })
      .optional(),
    cta: z.object({
      label: z.string(),
      action: z
        .object({
          web: z.object({
            link: z.string(),
            external: z.boolean().optional()
          })
        })
        .optional()
    })
  })
})
